import ReportTemplateRowMenu from "./ReportTemplateRowMenu";

const reportTemplateColumns = (t, isAiMode = false) => {
    const cols = [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            sorter: true,
            render: (text, record) => (
                <ReportTemplateRowMenu row={record} isAiMode={isAiMode} />
            )
        },
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        !isAiMode && {
            title: t('Language'),
            dataIndex: 'language',
            key: 'language',
            sorter: true,
            render: (text, record) => record.language
        },
        {
            title: t('Request Type'),
            dataIndex: 'requestType.name',
            key: 'requestType.name',
            sorter: true,
            render: (text, record) => record.requestType.name,
        },
        {
            title: t('Sut Code'),
            dataIndex: 'requestType.sutCode',
            key: 'requestType.sutCode',
            sorter: true,
            render: (text, record) => record.requestType.sutCode,
        },
        {
            title: t('Modality'),
            dataIndex: 'requestType.modality.name',
            key: 'requestType.modality.name',
            sorter: true,
            render: (text, record) => record.requestType.modality.name,
        },
    ].filter(Boolean);

    return cols;
};

export default reportTemplateColumns;
